export const TAX_FORM = {
  txForm: document.querySelector('#aafp_add-new-tax') as HTMLFormElement,
  txName: document.querySelector('#aafp_form-tax-name') as HTMLInputElement,
  txAmount: document.querySelector('#aafp_form-tax-percent-number') as HTMLInputElement,
  txType: document.querySelector('#aafp_dropdown-button-tax-type') as HTMLElement,
  txPartner: document.querySelector('#aafp_dropdown-button-partner') as HTMLElement,
  txPartnerContainer: document.querySelector('.aafp_dropdown-container-partner') as HTMLElement,
  txSubmitButton: document.querySelector('#aafp_tax-new-submit') as HTMLElement,
  txModal: document.querySelector('.aafp_modal') as HTMLElement
}

export const TAX_TYPE = [
  { id: 'P', name: 'Percent' },
  { id: 'C', name: 'Cents per gallon' }
]